import React from "react";
import { Box } from "@mui/material";

import ProjectCard from "./ProjectCard";

export default function ProjectList({
    projects = [],
    onOpenProject,
}) {
    return (
        <Box
            sx={{
                display: "flex",
                gap: 2,
                height: "100%",
                minWidth: 0,
            }}
        >
            {projects.map((project) => (
                <Box
                    key={project.id}
                    sx={{
                        flex: 1,
                        minWidth: 0,
                    }}
                >
                    <ProjectCard
                        {...project}
                        onOpen={() => onOpenProject?.(project.id)}
                    />
                </Box>
            ))}
        </Box>
    );
}